import { render, staticRenderFns } from "./LedgerQuery.vue?vue&type=template&id=6bcb6721"
import script from "./LedgerQuery.vue?vue&type=script&lang=js"
export * from "./LedgerQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports